import config from '../..//services/config';



class HitArea {
    constructor(id, points, maxBounds, hitAreaType) {
        //var self = this;

        this.id = id;
        this.pointsArray = points;
        this.x = maxBounds.x !== undefined ? maxBounds.x : maxBounds.position ? maxBounds.position.x : 0;
        this.y = maxBounds.y !== undefined ? maxBounds.y : maxBounds.position ? maxBounds.position.y : 0;
        this.width = maxBounds.width;
        this.height = maxBounds.height;
        this.type = 'hitArea';
        this.flipYAxisVal = true;
        this.doScaling = false;

        this.interactionBehaviour = config.INTERACTION_BEHAVIOUR.STANDARD;
        
        this.hitMasks = undefined;

        this.interaction = null;
        
        this.draggable = null;
        
        
        this.disableDrag = false;
        this.hitAreaType = hitAreaType;
        return this;
    }

    setInteraction(interactionObj) {
        this.interaction = interactionObj;
        return this;
    }

    setDraggable(interactionObj) {
        this.draggable = interactionObj;
        return this;
    }

    setFlipYAxis(flip) {
        this.flipYAxisVal = flip;
        return this;
    }

    setDoScaling(doScaling) {
        this.doScaling = doScaling;
        return this;
    }

    setDisableDrag(disable) {
        this.disableDrag = disable;
        return this;
    }

    setInteractionBehaviour(interactionBehaviour) {
        this.interactionBehaviour = interactionBehaviour;
        return this;

    }

    addHitMask(subHitArea) {
        if (this.hitMasks === undefined) {
            this.hitMasks = [];
            //if (this.interaction) {
            //    this.interaction.hitMasks = this.hitMasks;
            //}
        }
        this.hitMasks.push(subHitArea);
        return this;
    }

    addLinkedHitAreaId(linkedHitAreaId) {
        this.linkedHitAreaId = linkedHitAreaId;
        return this;
    }

    addMenuPath(menuPath) {
        this.menuPath = menuPath;
        return this;
    }

}

export default HitArea;
